import React from "react";
import { Box } from "@mui/material";
import Sidebar from "./sidebar/Sidebar";
import Navbar from "./Navbar";

const drawerWidth = 200;

const UserDashboardLayout = ({ showNavbar = true, hideSidebarOnDesktop = false, ...props }) => {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <div>
        <Sidebar
          mobileOpen={mobileOpen}
          handleDrawerToggle={handleDrawerToggle}
          hideSidebarOnDesktop={hideSidebarOnDesktop}
        />
        <Box
          sx={{
            ml: { md: hideSidebarOnDesktop ? 0 : `${drawerWidth}px`, xs: 2 },
            paddingTop: showNavbar ? 2 : 0, // Adjust padding based on navbar visibility
          }}
        >
          {showNavbar && (
            <Navbar
              headingTitle={props.navTitle}
              handleDrawerToggle={handleDrawerToggle}
            />
          )}
          {props.children}
        </Box>
      </div>
    </>
  );
};

export default UserDashboardLayout;